import { DeleteOutlined } from '@ant-design/icons';
import { Image, message, Space, Table, TableColumnsType } from 'antd';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { Dispatch, SetStateAction, useState } from 'react';
import productStore from '../../../../stores/productStore';
import ActionButton from '../../../atoms/ButtonComponent';
import ContentBox from '../../../molecules/ContentBox';
import ModalComponent from '../../../organisms/ModalComponent';
import DrawerImagemUpload from './DrawerUploadImage';
import DrawerUploadUrl from './DrawerUploadUrl';

interface DataType {
    path: any;
    ordering: any;
    center: any;
    displayUnits: any;
    baseQty: string;
    name: string;
    uuid: any;
    key: React.Key;
}

interface UplodFileProductProps {
    setActive: Dispatch<SetStateAction<boolean>>
    active: boolean
}

const UplodFileProduct: React.FC<UplodFileProductProps> = observer(({ setActive, active }) => {
    const { loading, product } = productStore;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [itemSelected, setItemSelected] = useState<any>();
    const [openModalRegister, setOpenModalRegister] = useState(false);
    const [openModalRegisterUrl, setOpenModalRegisterUrl] = useState(false);
    const { setFieldValue } = useFormikContext<any>();

    const columns: TableColumnsType<DataType> = [
        {
            title: 'Imagem',
            dataIndex: 'path',
            key: 'path',
             width: 100,
            render: (path) => {
                return (
                    <Image
                        width={50}
                        src={path}
                    />
                );
            },
        },
        {
            title: 'Ordenação',
            dataIndex: 'ordering',
            key: 'ordering',
            width: 100
        },
        {
            title: 'Url Imagem',
            dataIndex: 'path',
            key: 'path',
            ellipsis: true, // 👈 já cuida do truncamento
            render: (path) => (
                <p className="truncate whitespace-nowrap overflow-hidden" title={path}>{path}</p>
            ),
        },
        {
            title: 'Deletar',
            dataIndex: 'delete',
            key: 'delete',
            align: 'center',
            width: 80,
            render: (text, record) => (
                <Space className="cursor-pointer" onClick={() => showModal(record)}>
                    <div ><DeleteOutlined /></div>
                </Space>
            ),
        },
    ];


    const showModal = (record: any) => {
        setItemSelected(record);
        setIsModalOpen(true);
    };

    const handleDeleteItem = () => {
        const newFiles = product.files;

        if (newFiles.length === 1 && active === true) {
            setFieldValue("active", false);
            setActive(false);
            message.error('Produto desativado, cadastre uma imagem');
        }

        productStore.removeImage(itemSelected);
        setIsModalOpen(false);
    };


    return (
        <div>
            <ContentBox className="mb-4 p-6" borderCustom='rounded-b-lg' title="Cadastro de Imagem" description='Listagem de imagens cadastradas' actions={
                <div className="flex gap-4">
                    <ActionButton icon actionType="create" onClick={() => setOpenModalRegister(true)}>Cadastrar imagem por Upload</ActionButton>
                    <ActionButton icon actionType="create" onClick={() => setOpenModalRegisterUrl(true)}>Cadastrar imagem por URL</ActionButton>
                </div>
            }>
                <div>
                    <Table
                        className="table-custom"
                        columns={columns}
                        dataSource={product && product?.files.map((item: any, index: number) => ({
                            ...item,
                            key: item.uuid || index,
                        }))}
                        loading={loading}
                        size="middle"
                        bordered={false}
                        pagination={false}
                    />
                </div>

                {isModalOpen && <ModalComponent
                    title="Aviso"
                    content={<p>Você deseja excluir a Unidade <b>{itemSelected?.name}</b>?</p>}
                    isModalOpen={isModalOpen}
                    handleOk={handleDeleteItem}
                    handleCancel={() => setIsModalOpen(false)}
                />}
            </ContentBox>

            {openModalRegister && <DrawerImagemUpload isModalOpen={openModalRegister} setIsModalOpen={setOpenModalRegister} />}
            {openModalRegisterUrl && <DrawerUploadUrl isModalOpen={openModalRegisterUrl} setIsModalOpen={setOpenModalRegisterUrl} />}
        </div>
    );
});

export default UplodFileProduct;